module.exports = __webpack_public_path__ + "static/img/CgoRC2ORiS-ASlDKABNFQqmPqwc522.c4ea9c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRC2ORiS-ASlDKABNFQqmPqwc522.png
// module id = 8maK
// module chunks = 73